import { NetworkIntegrityAggregateGroup, NetworkIntegrityAggregateKey } from "@app/projects/enumerators";

const getAggregateKeyValueForPendo = (aggregateKey: NetworkIntegrityAggregateKey): string => {
  switch(aggregateKey) {
    case NetworkIntegrityAggregateKey.DeactivatedNpi:
      return "deactivated-npi";
    case NetworkIntegrityAggregateKey.ElevenPlusAddresses:
      return "eleven-plus-addresses";
    case NetworkIntegrityAggregateKey.InvalidNpi:
      return "invalid-npi";
    case NetworkIntegrityAggregateKey.MissingNpi:
      return "missing-npi";
    case NetworkIntegrityAggregateKey.SixPlusAddresses:
      return "six-plus-addresses";
    case NetworkIntegrityAggregateKey.SixPlusSpecialties:
      return "six-plus-specialties";
    case NetworkIntegrityAggregateKey.ThreePlusSpecialties:
      return "three-plus-specialties";
    default:
      return aggregateKey;
  }
};

const getPendoClassNameForAggregateKey = (aggregateKey: NetworkIntegrityAggregateKey): string => {
  const pendoKey = getAggregateKeyValueForPendo(aggregateKey);
  return pendoKey ? `${normalizePendoClassName(pendoKey)}` : '';
}

const getAggregateGroupValueForPendo = (aggregateGroup: NetworkIntegrityAggregateGroup): string => {
  switch(aggregateGroup) {
    case NetworkIntegrityAggregateGroup.NetworkSummary:
      return "network-summary";
    case NetworkIntegrityAggregateGroup.OptionalExclusions:
      return "optional-exclusions";
    case NetworkIntegrityAggregateGroup.ExcessAddresses:
      return "excess-addresses";
    case NetworkIntegrityAggregateGroup.ExcessSpecialties:
      return "excess-specialties";
    case NetworkIntegrityAggregateGroup.ProvidersByState:
      return "providers-by-state";
    case NetworkIntegrityAggregateGroup.ProvidersByCounty:
      return "providers-by-county";
    case NetworkIntegrityAggregateGroup.ProvidersByZipCode:
      return "providers-by-zip-code";
    case NetworkIntegrityAggregateGroup.ProvidersByGeocode:
      return "providers-by-geocode";
    case NetworkIntegrityAggregateGroup.ProvidersBySpecialty:
      return "providers-by-specialty";
    case NetworkIntegrityAggregateGroup.CriticalAlerts:
      return "critical-alerts";
    case NetworkIntegrityAggregateGroup.AttestationBasedAlerts:
      return "attestation-based-alerts";
    case NetworkIntegrityAggregateGroup.AllExcessWarnings:
      return "all-excess-warnings";
  }
};

const getPendoClassNameForAggregateGroup = (aggregateGroup: NetworkIntegrityAggregateGroup, modifier?: string): string => {
  const pendoKey = getAggregateGroupValueForPendo(aggregateGroup);
  return pendoKey ? `${normalizePendoClassName(pendoKey)}${modifier ? "-" + modifier : ''}` : '';
}

const getPendoClassNameForDynamicAggregateKey = (aggregateKey: string): string => {
  let pendoClassName = aggregateKey;
  if (pendoClassName.includes("Ghost Providers")) {
    pendoClassName = pendoClassName.includes("Total Claims") ? "ghost-providers" : "ghost-providers-lob";
  }
  return normalizePendoClassName(pendoClassName);
}

const normalizePendoClassName = (name: string): string => {
  return name.toLocaleLowerCase().replaceAll(" ", "-").replace(/[\(\)]/g, "");
}

export { getPendoClassNameForAggregateKey, getPendoClassNameForDynamicAggregateKey, getPendoClassNameForAggregateGroup };